import { Divider } from '@mui/material';

const sx = { borderColor: 'disabled', my: 0.5 };

/**
 * Vertical divider used between controls in the stream controls bar.
 */
export function ControlDivider() {
  return <Divider orientation="vertical" flexItem sx={sx} />;
}
